module.exports = __webpack_public_path__ + "img/logo_placeholder-new.dde19137.svg";